import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctDecimals, FctValue } from '../../../../Fct/generics';
import { supportedContracts } from '../constants';
export var Between = createPlugin({
    protocol: 'TOKEN_VALIDATOR',
    type: 'VALIDATOR',
    method: 'between',
    description: 'Check if amountIn is between minAmount and maxAmount',
    supportedContracts: supportedContracts,
    getParams: function () { return ({
        input: {
            to: new FctAddress({}),
            methodParams: {
                minAmount: new FctValue({ destination: 'wei_amount' }),
                minDecimals: new FctDecimals({}),
                maxAmount: new FctValue({ destination: 'wei_amount' }),
                maxDecimals: new FctDecimals({}),
                amountIn: new FctValue({ destination: 'wei_amount' }),
                decimalsIn: new FctDecimals({}),
                decimalsOut: new FctDecimals({}),
            },
        },
        output: {
            result: new FctValue({
                description: 'amountIn - minAmount',
                innerIndex: 0,
            }),
        },
    }); },
});
